import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

export const ObservationText = styled.span`
  line-height: ${theme.typography.lineHeight.lg};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
`

export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`

export const ValueWrapper = styled(ValueRow)`
  flex-wrap: wrap;
  justify-content: space-between;
`

export const TitleRow = styled(ValueRow)`
  gap: ${theme.spacing.xs};
`

export const ValueTexts = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const OverviewValues = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.md};
  margin: ${theme.spacing['2xm']} 0;
`

export const Title = styled.span`
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.high};
  line-height: ${theme.typography.lineHeight.sm};
`

export const Value = styled.span`
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.neutral.medium};
  line-height: ${theme.typography.lineHeight.sm};
`

export const CurrencyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const ActionsRow = styled.div`
  display: flex;
  width: 100%;
  gap: ${theme.spacing.sm};
  justify-content: flex-end;

  button {
    height: 40px;
  }
`

export const TooltipIcon = styled(InfoOutlinedIcon)`
  color: ${theme.colors.primary.main};
  font-size: ${theme.typography.sizes['2xs']};
`
